module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-sponsors"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Sponsors"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-vcentered is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subnavs), function(subnav) {
    return _c('div', {
      key: "subnav.title",
      staticClass: "column is-narrow subnav-item"
    }, [_c('a', {
      attrs: {
        "href": subnav.section ? (_vm.$route.name + '?anchor=' + subnav.section) : subnav.route
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onScrollTo(subnav.route, subnav.section)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": require("../assets/ic_info.svg"),
        "width": "80"
      }
    }), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "text"
    }, [_vm._v("\n              " + _vm._s(subnav.title) + "\n            ")])])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('div', {
    staticClass: "sponsors-official"
  }, [_c('page-subheader', {
    attrs: {
      "title": "Official Partners",
      "text-align": 'center',
      "title-style": {
        borderBottom: '0px'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-flex-mobile is-multiline"
  }, _vm._l((_vm.mnames), function(mname) {
    return (_vm.mitems[mname]) ? _c('div', {
      key: mname,
      staticClass: "column is-3 is-6-mobile has-text-centered item-wrapper"
    }, [(_vm.mitems[mname].link) ? _c('a', {
      staticClass: "item",
      attrs: {
        "href": _vm.mitems[mname].link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })]) : _c('a', {
      staticClass: "item",
      attrs: {
        "href": '/about?anchor=' + mname
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })])]) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-6",
      "title": "21st Edition Sponsors",
      "level": "6"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-1",
      "title": "J.D. Hogg Sponsors",
      "level": "1"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-2",
      "title": "The Duke Boys Sponsors",
      "level": "2"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-3",
      "title": "Uncle Jesse Sponsors",
      "level": "3"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-4",
      "title": "Roscoe P. Coltrane",
      "level": "4"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-5",
      "title": "Daisy Duke Sponsors",
      "level": "5"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-0",
      "level": "0",
      "index": "0",
      "is-alt": "true",
      "is-limit-content": "true"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-0",
      "level": "0",
      "index": "1",
      "is-alt": "false"
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a31b36c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sponsors.vue
// module id = 918
// module chunks = 1